import { useState, useEffect } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, IconButton, Container, Box, Typography, LinearProgress } from "@mui/material";
import apiClient from "../api/apiClient";
import CloseIcon from "@mui/icons-material/Close";

import * as React from "react";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField, InputAdornment } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const ProcessBankSap = () => {
  const [jobId, setJobId] = useState(null);
  const [jobStatus, setJobStatus] = useState("");
  const [loading, setLoading] = useState(false);  // State สำหรับการโหลด

  const [value, setValue] = useState(null);
  // const [monthYear, setMonthYear] = React.useState(dayjs());
  const [error, setError] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [openDialog, setOpenDialog] = useState(false); // การแสดง Dialog
    const [dialogMessage, setDialogMessage] = useState(""); // ข้อความที่จะแสดงใน Dialog
    const [dialogTitle, setDialogTitle] = useState("Information"); // ค่าเริ่มต้นเป็น Error
    const [dialogTitleColor, setDialogTitleColor] = useState("black"); 
    const [dialogButtonText, setDialogButtonText] = useState("Close"); // ข้อความปุ่มเริ่มต้นเป็น Close
    const [dialogButtonTextColor, setDialogButtonTextColor] = useState("black"); 
    const [dialogButtonColor, setDialogButtonColor] = useState("white"); 
    const [dialogButtonColorh, setDialogButtonColorh] = useState("white"); 

      const [progress, setProgress] = useState(0); // To track the loading progress
      const [loadingstart, setLoadingstart] = useState(true); // To show loading spinner

  const [status, setStatus] = useState(null); 
  // const [missingTables, setMissingTables] = useState([]);

  const token = localStorage.getItem("token");

  const fetchConfigData = async () => {
    setLoadingstart(true);
    setProgress(0);
    try {
      const response = await apiClient.get("/api-data/debttransaction-check", {
          params: { screen: "ProcessBankSap" }, 
          headers: { "Authorization": `Bearer ${token}` }
      });

      if (response.data) {
        const { filename, filenamet, data_count} = response.data;

        setStatus({
          filename: filename,
          filenamet: filenamet,
          data_count: data_count,
        });
        // setMissingTables(missingTables);

      } else {
        setStatus(null);
      }

      // setLoadingstart(false); // Data loaded, hide progress bar

    } catch (error) {
      // console.error("Failed to fetch data status:", error);
      // setLoadingstart(false); // Hide loading in case of error
    }
    setLoadingstart(false);
    setProgress(100); 
  };


  useEffect(() => {
    fetchConfigData();
  }, []);

  // เริ่มงาน Reconcile
  const handleStartJob = async () => {   
    setLoadingstart(true);
    setProgress(0);
 
    try {
      if (!startDate) {
        setError(true);
        setLoadingstart(false);
        setProgress(100);
        return;
      }

      let getendDate = null;
      if (endDate) {
        getendDate = dayjs(endDate).format('YYYY-MM-DD') ;
      }

      setError(false);
      // setLoading(true);  // เริ่มแสดง loading
        
      const d = {
        s: "ProcessBankSap",       
        filename: status.filename ,
        filenamet: status.filenamet ,
        startdate: dayjs(startDate).format('YYYY-MM-DD') ,
        enddate: getendDate
      };

      // const response = await apiClient.post("/api-reconcile/process-start", dataToSend, {
      const response = await apiClient.post("/api-process/a0002", d, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        if (response.data.status === 'INSERT_SUCCESSFUL') {
          openDialogWithMessage(response.data.message, "Reconcile Complete", "#519a39", "OK", "white", "#66bb49", "#3f762c");
          setStatus(null);
        } else {
          console.log(response.data.error);
          openDialogWithMessage(response.data.message, "Warning", "#ffa000", "OK", "white", "#ffb300", "#ff6f00");
        }
      }
      // setLoading(false);
      // setJobId(response.data.jobId);
      // setJobStatus("กำลังดำเนินการ...");
      // await checkJobStatus(response.data.jobId);  // รอจนกว่างานจะเสร็จ
    } catch (error) {
      // console.error("Error starting job:", error);
      // setJobStatus("เกิดข้อผิดพลาดในการเริ่มงาน");
      // setLoading(false);  // ซ่อน loading เมื่อเกิดข้อผิดพลาด
    }
    setLoadingstart(false);
    setProgress(100);
  };
  

  // ตรวจสอบสถานะงาน
 // ฟังก์ชันสำหรับตรวจสอบสถานะ
const checkJobStatus = async (jobId) => {
  const interval = setInterval(async () => {
    try {
      const response = await apiClient.get(`/api-process/process-status/${jobId}`);
      setJobStatus(response.data.status);
      if (response.data.status === "completed") {
        setLoading(false);  // ซ่อน loading เมื่อเสร็จ
        clearInterval(interval);  // หยุดการตรวจสอบสถานะ
      }
    } catch (error) {
      console.error("Error checking job status:", error);
      setJobStatus("เกิดข้อผิดพลาดในการตรวจสอบงาน");
      setLoading(false);  // ซ่อน loading เมื่อเกิดข้อผิดพลาด
      clearInterval(interval);  // หยุดการตรวจสอบสถานะ
    }
  }, 2000);  // ตรวจสอบทุกๆ 2 วินาที
};


  const openDialogWithMessage = (message, title = "Information", titleColor = "black", buttonText = "Close", buttonTextColor = "black", buttonColor = "white", buttonColorh = "white") => {
    setDialogMessage(message);
    setDialogTitle(title);
    setDialogTitleColor(titleColor);
    setDialogButtonText(buttonText);
    setDialogButtonTextColor(buttonTextColor);
    setDialogButtonColor(buttonColor);
    setDialogButtonColorh(buttonColorh);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (

    <Container component="main" maxWidth="96%" sx={{marginTop: "40px",border: "0px solid #e0e0e0",boxSizing: "border-box",}}>

      {/* Loading Progress Bar */}
            {loadingstart ? (
              <Box sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                zIndex: 999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}>
                <LinearProgress variant="determinate" value={progress} sx={{ width: '50%' }} />
              </Box>
      
             ) : ( 


      <Box sx={{ width: '100%',display: "flex",flexDirection: "column", marginLeft:0, marginBottom:0, boxShadow: "none",marginTop: "0px",border: "0px solid #e0e0e0" ,boxSizing: "border-box",
        backgroundColor: "background.paper",
      }}>
        <Box sx={{ borderRadius: 0,boxSizing: "border-box",marginBottom:0, boxShadow: "none",marginTop: "0px",
          textAlign: "center",
          verticalAlign: "middle",
          padding:1,
          backgroundColor: "#f5f5f5",
          fontSize: "calc(14px + 0.5vw)",
          fontWeight: "bold",
          color: "#333",
        }}>
          การกระทบยอด (Reconcile) - ข้อมูลรายการเดินบัญชีจากธนาคาร กับ ข้อมูล SAP
        </Box>

        {status?.filename !== "NOFILE" && status?.data_count > 0 ? (
          <>

          <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "4px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
                                  borderRadius: 0,textAlign: "center",verticalAlign: "middle",fontSize: "calc(14px - 0.01vw)",padding:1,
                                  display: "flex",            // ✅ เพิ่ม
                                  justifyContent: "center",   // ✅ จัดให้อยู่ตรงกลางแนวนอน
                                  alignItems: "center",
                                  gap: 2, flexWrap: "wrap",
                                }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            {/* <Box sx={{ display: 'flex',flexDirection: "column", gap: 2, alignItems: 'center',boxSizing: "border-box" }}> */}
              
              <Typography variant="body2" sx={{ marginBottom:0, boxShadow: "none",marginTop: "0px",
                textAlign: "center",
                verticalAlign: "middle",
                padding:1,
                fontSize: "calc(14px + 0.1vw)",
                // fontWeight: "bold",
                color: "#333",
              }}>
                เลือกวันที่ข้อมูลจากธนาคาร
              </Typography>

              <DatePicker
                label="เลือกวันที่เริ่มต้น*"
                value={startDate}
                onChange={(newValue) => {
                  setStartDate(newValue);
                  setError(false);
                  // ถ้าเปลี่ยน startDate ใหม่ และ endDate น้อยกว่า startDate ให้ reset endDate
                  if (endDate && newValue && endDate < newValue) {
                    setEndDate(null);
                  }
                }}
                sx={{ width: 190 }}
                slotProps={{
                  field: { clearable: true, onClear: () => setStartDate(null) },
                  textField: { 
                    size: 'small',
                    placeholder: 'Select Date',
                    error: error,
                    helperText: error && !startDate ? 'กรุณาเลือกวัน' : '',
                  },
                  // textField: {
                  //   variant: 'outlined',
                  //   error,
                  //   helperText: error && !startDate ? 'จำเป็นต้องเลือก' : '',
                  //   size: 'small',
                  // },
                }}
              />
              <DatePicker
                label="เลือกวันที่สิ้นสุด"
                value={endDate}
                onChange={(newValue) => {
                  setEndDate(newValue);
                  setError(false);
                }}
                disabled={!startDate}  // <-- ถ้า startDate ยังไม่เลือก disable ไว้
                minDate={startDate}     // <-- กำหนดวันที่น้อยสุดของ endDate เป็น startDate
                sx={{ width: 190 }}
                slotProps={{
                  field: { clearable: true, onClear: () => setEndDate(null) },
                  textField: { size: 'small',placeholder: 'Select End Date'},
                  // textField: {
                  //   variant: 'outlined',
                  //   // error,
                  //   // helperText: error && !endDate ? 'จำเป็นต้องเลือก' : '',
                  //   size: 'small',
                  // },
                }}
              />
              
            {/* </Box> */}
          </LocalizationProvider>
          </Box>

          <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "4px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
                                  borderRadius: 0,textAlign: "center",verticalAlign: "middle",fontSize: "calc(14px - 0.01vw)",padding:1,
                                  display: "flex",            // ✅ เพิ่ม
                                  justifyContent: "center",   // ✅ จัดให้อยู่ตรงกลางแนวนอน
                                  alignItems: "center",
                                  gap: 2, flexWrap: "wrap",
                                }}>
              
              <Typography variant="body2" sx={{ marginBottom:0, boxShadow: "none",marginTop: "0px",
                textAlign: "center",
                verticalAlign: "middle",
                padding:1,
                fontSize: "calc(14px + 0.1vw)",
                // fontWeight: "bold",
                color: "#333",
              }}>
                กระทบยอดจากไฟล์ : {status?.filename}
              </Typography>

          </Box>

          {/* <TableContainer
            component={Paper}
            sx={{
              maxHeight: 200,
              overflow: "auto", // ให้ scroll แนวตั้ง
              minWidth: 400,     // บังคับให้มี scroll แนวนอนถ้าเนื้อหากว้าง
              width: '60%',
            }}
          >
            <Table size="small" aria-label="a dense table" sx={{ borderCollapse: 'collapse' }}>
              <TableHead sx={{ backgroundColor: '#f5f5f5',whiteSpace: "nowrap", }}>
                  <TableRow>
                    <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ไฟล์ข้อมูลจากระบบ SAP</TableCell>

                  </TableRow>
              </TableHead>

              <TableBody>
                  <TableRow>
                    <TableCell align="center" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >
                      {status?.filename.substring(9)}
                    </TableCell>
                  </TableRow>
              </TableBody>

            </Table>
          </TableContainer> */}


        <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "4px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
          borderRadius: 0,
        }}>          

          <Typography variant="body2" sx={{ marginBottom:0, boxShadow: "none",marginTop: "0px",
            textAlign: "center",
            verticalAlign: "middle",
            padding:1,
            fontSize: "calc(14px + 0.2vw)",
            fontWeight: "bold",
            color: "#333",
          }}>
            
            <button
              onClick={handleStartJob}
              style={{
                padding: "8px 15px",
                background: "#0061d4",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: "calc(8px + 0.5vw)",
                marginRight: "10px",
              }}
            >
              เริ่มการกระทบยอด
            </button>

          </Typography>
          

          {/* <Typography variant="body2" sx={{ marginBottom:0, boxShadow: "none",marginTop: "0px",
            textAlign: "center",
            verticalAlign: "middle",
            padding:1,
            fontSize: "calc(14px - 0.1vw)",
            fontWeight: "bold",
            color: "#333",
          }}>
            Job ID: {jobId || "ยังไม่มีงาน"}
          </Typography> */}

          {/* <Typography variant="body2" sx={{ marginBottom:0, boxShadow: "none",marginTop: "0px",
            textAlign: "center",
            verticalAlign: "middle",
            padding:1,
            fontSize: "calc(14px + 0.1vw)",
            fontWeight: "bold",
            color: "#333",
          }}>
            Status: {jobStatus}
          </Typography> */}

          {loading && <LinearProgress sx={{ marginTop: 2 }} />}

          <Typography variant="body2" sx={{ marginBottom:0, boxShadow: "none",marginTop: "0px",
            textAlign: "center",
            verticalAlign: "middle",
            padding:1,
            fontSize: "calc(14px - 0.1vw)",
            // fontWeight: "bold",
            color: "#333",
          }}>
            * ระบบจะกระทบยอดจากข้อมูลรายการเดินบัญชีจากธนาคารในช่วงเวลาที่เลือก กับข้อมูลจากระบบ SAP ตามไฟล์ที่อัพโหลดล่าสุด
          </Typography>

        </Box>

        </>
        ) : status?.filename != "NOFILE" && status?.data_count == 0 ? (

          <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "4px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
          borderRadius: 0,
        }}>

          <Typography variant="body2" sx={{ marginBottom:0, boxShadow: "none",marginTop: "0px",
            textAlign: "center",
            verticalAlign: "middle",
            padding:1,
            fontSize: "calc(14px + 0.1vw)",
            fontWeight: "bold",
            color: "#e40000",
          }}>
            {"กรุณาอัพโหลดไฟล์ข้อมูล SAP รายงานแยกประเภทตามธนาคาร ที่มีข้อมูลธุรกรรม"}
          </Typography>

        </Box>

        ) : (

        <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "4px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
          borderRadius: 0,
        }}>

          <Typography variant="body2" sx={{ marginBottom:0, boxShadow: "none",marginTop: "0px",
            textAlign: "center",
            verticalAlign: "middle",
            padding:1,
            fontSize: "calc(14px + 0.1vw)",
            fontWeight: "bold",
            color: "#e40000",
          }}>
            {"ไม่พบการอัพโหลดข้อมูล SAP รายงานแยกประเภทตามธนาคาร กรุณาอัพโหลดไฟล์และนำข้อมูลเข้าระบบ"}
          </Typography>

        </Box>

        )}

      </Box>

      )}

      <Dialog open={openDialog} onClose={handleCloseDialog} sx={{maxWidth: "auto",  width: "auto", margin: "auto",overflow: "visible", }}>
          <DialogTitle sx={{color: dialogTitleColor,fontSize: "1.3rem",fontWeight: "400",textAlign: "left",padding: "5px",minHeight: "30px",whiteSpace: "pre-wrap",paddingRight: "40px", }}>
          {dialogTitle} 
          </DialogTitle>
          <IconButton sx={{position: "absolute",right: "5px",top: "3px",borderRadius: "8px", }} onClick={handleCloseDialog}> 
              <CloseIcon /> 
          </IconButton>
          <DialogContent sx={{ fontSize: "1rem",maxHeight: "100%", overflowY: "auto", paddingBottom: "0",whiteSpace: "pre-wrap",wordBreak: "break-word",textAlign: "center", }}>
          {dialogMessage}
          </DialogContent>
          <DialogActions sx={{display: "flex", justifyContent: "center", alignItems: "center",marginTop: "20px",}}>
          <Button variant="contained" sx={{ backgroundColor: dialogButtonColor, color: dialogButtonTextColor, "&:hover": { backgroundColor: dialogButtonColorh } }} onClick={handleCloseDialog}>
              {dialogButtonText}
          </Button>
          </DialogActions>
      </Dialog>

    </Container>


  );
};

// CSS Style
const styles = {
  button: {
    margin: "10px",
    padding: "10px 20px",
    fontSize: "16px",
    cursor: "pointer",
    backgroundColor: "#007BFF",
    color: "white",
    border: "none",
    borderRadius: "5px",
  },
};

export default ProcessBankSap;
